import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const addResearchPublications = async ({ title, abstract, file, authors,journal_name,publication_date}) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addResearchPublications`,
            { title, abstract, file, authors, journal_name, publication_date},
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const getResearchPData = async ({ page = 1, pageSize = 10 }) => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getResearchPublications?page=${page}&page_size${pageSize}`);
       // console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteResearchPData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteResearchPublications/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editResearchPData = async ({ id, title, abstract, file, authors,journal_name,publication_date }) => {
    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateResearchPublications/${id}`,
            { title, abstract, file, authors,journal_name,publication_date },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}